module.exports = __webpack_public_path__ + "static/img/xcgc.815038f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/thumbnail/xcgc.jpg
// module id = Xhbm
// module chunks = 2